//@flow
import { url as urlUtils } from '@clubmed/utils';

import { buildProductArgs } from 'Utils/graphql';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { WIDGET_CRUISE_BOOKING_CALL_PRICE } from 'Utils/request/requestDictionary';

export type PriceType = {
  price: {
    bestPrice: {
      value: string,
      formattedValue: string,
    },
    termsAndConditions: {
      departureDate: string,
      arrivalDate: string,
      duration: string,
    },
    unit: string,
  },
};

type Args = {
  appContext: AppContext,
  departureCity: string,
  location: RouterLocation<{}, { offer: string }>,
  productId: string,
};

export const callPrice = ({
  appContext,
  departureCity = '',
  location: {
    queryParams: { offer },
  },
  productId,
}: Args): Promise<PriceType> => {
  const offerName = offer ? urlUtils.decodePath(offer) : '';
  const productArgs = buildProductArgs(productId, {}, { offerName, departureCity });
  const { cmsContent, cmsRelease } = appContext;
  const cmsArgs = `content : "${cmsContent}" release : "${cmsRelease}"`;

  const query = `{
          price(${productArgs}) {
            bestPrice {
              value
              formattedValue
            }
            termsAndConditions {
              departureDate
              arrivalDate
              duration
            }
            unit(${cmsArgs})
          }
        }`;
  return graphQLClient.runQuery(query, appContext, {
    requestName: WIDGET_CRUISE_BOOKING_CALL_PRICE,
  });
};
